import PlusIcon from '../../../assets/icons/plus.svg?react';
import styled, { useTheme } from 'styled-components';

const NewCardContainer = styled.div`
  width: 100%;
  aspect-ratio: 16 / 10;
  background-color: ${({ theme }) => theme.background.light};
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.border.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const BorderTopLeft = styled.div`
  position: absolute;
  top: -3px;
  left: -3px;
  width: 50px;
  height: 50px;
  border: 6px solid ${({ theme }) => theme.text.secondary};
  border-top-left-radius: 11px;
  border-right: none;
  border-bottom: none;
`;

const BorderTopRight = styled.div`
  position: absolute;
  top: -3px;
  right: -3px;
  width: 50px;
  height: 50px;
  border: 6px solid ${({ theme }) => theme.text.secondary};
  border-top-right-radius: 11px;
  border-left: none;
  border-bottom: none;
`;

const BorderBottomLeft = styled.div`
  position: absolute;
  bottom: -3px;
  left: -3px;
  width: 50px;
  height: 50px;
  border: 6px solid ${({ theme }) => theme.text.secondary};
  border-bottom-left-radius: 11px;
  border-right: none;
  border-top: none;
`;

const BorderBottomRight = styled.div`
  position: absolute;
  bottom: -3px;
  right: -3px;
  width: 50px;
  height: 50px;
  border: 6px solid ${({ theme }) => theme.text.secondary};
  border-bottom-right-radius: 11px;
  border-left: none;
  border-top: none;
`;

const NewCard = () => {
  const theme = useTheme();

  return (
    <NewCardContainer>
      <BorderTopLeft />
      <BorderTopRight />
      <BorderBottomLeft />
      <BorderBottomRight />
      <PlusIcon width={'30%'} height={'30%'} color={theme.text.secondary} />
    </NewCardContainer>
  );
};

export default NewCard;
